import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProveedorIndexComponent } from './proveedor-index/proveedor-index.component';
import { ProveedorViewComponent } from './proveedor-view/proveedor-view.component';
import { ProveedorCreateComponent } from './proveedor-create/proveedor-create.component';
import { ProveedorUpdateComponent } from './proveedor-update/proveedor-update.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'index', component: ProveedorIndexComponent },
  { path: '**', redirectTo: 'index' }
];

@NgModule({
  declarations: [
    ProveedorIndexComponent,
    ProveedorViewComponent,
    ProveedorCreateComponent,
    ProveedorUpdateComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgSelectModule
  ]
})
export class ProveedorModule { }
